module.exports = __webpack_public_path__ + "static/img/wxpay.c9e7d01e.jpeg";